import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useLocation } from 'react-router-dom';

import iconSupport1 from '../../../../assets/images/our-customer/Mask Group 175.svg';
import iconSupport2 from '../../../../assets/images/our-customer/Mask Group 176.svg';
import iconSupport3 from '../../../../assets/images/our-customer/Mask Group 177.svg';
import iconSupport4 from '../../../../assets/images/our-customer/Mask Group 178.svg';

import iconPhone from '../../../../assets/images/our-customer/Path 3569.svg';
import iconEmail from '../../../../assets/images/our-customer/Path 3570.svg';

import ImgReceptionEn from '../../../../assets/images/our-customer/ImgReceptionEn.svg';
import ImgReceptionJp from '../../../../assets/images/our-customer/ImgReceptionJp.svg';
import ImgReceptionVn from '../../../../assets/images/our-customer/ImgReceptionVn.svg';
// import ImgReceptionSmallEn from '../../../../assets/images/our-customer/ImgReceptionSmallEn.svg';
// import ImgReceptionSmallJp from '../../../../assets/images/our-customer/ImgReceptionSmallJp.svg';

import { getLanguage, getQueryString } from '../../../../utils/params';
import { getSupportServiceBanner } from 'modules/usefulPage/usefulPage.api';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';
import { getContactByType } from 'modules/helpPage/helps.api';

const OurCustomer = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { t } = useTranslation();
  const language = getLanguage(useLocation());
  const [imageUrl, setImageUrl] = useState(null);
  const [contact, setContact] = useState({});

  useEffect(() => {
    showLoader();
    const city = localStorage.getItem('LOCATION_CITY');
    Promise.all([
      getContactByType(getQueryString({ cityId: city ?? 1, language: language, type: 2 })),
      getSupportServiceBanner(getQueryString({ language })),
    ]).then(values => {
      if (values) {
        setContact(values[0][0] ?? {});
        setImageUrl(values[1][0]?.imageUrl);
      }
    });
    hideLoader();
    //eslint-disable-next-line
  }, []);

  return (
    <div className="page-our-customer">
      <div className="image-our">
        <LazyLoadImage src={`${process.env.REACT_APP_ISN_IMAGE_URL}${imageUrl}`} alt="" effect="blur" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12 trouble-shooting">
            <div className="row">
              <div className="col-12 col-md-12">
                <div className="title-trouble-shooting d-none d-md-block">{t('usefulPage.label_process')}</div>
                <div
                  className="title-trouble-shooting d-block d-md-none"
                  dangerouslySetInnerHTML={{
                    __html: t('usefulPage.label_process') || '',
                  }}
                ></div>
                <div className="description-trouble-shooting jp-font-sawarabi-gothic">
                  {t('usefulPage.label_process_desc')}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 reception-correspondence">
            <div className="row">
              <div className="col-12 col-md-3 content-left">
                <div className="title-secure">
                  <div className="text-time">
                    <div className="text-24-hours">{t('usefulPage.label_24h')}</div>
                    <div className="text-24-hours">{t('usefulPage.label_365day')}</div>
                    <div className="text-24-hours">{t('usefulPage.label_service')}</div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-9">
                <div className="content-right">
                  <img
                    src={language === 'en' ? ImgReceptionEn : language === 'jp' ? ImgReceptionJp : ImgReceptionVn}
                    alt=""
                    className="img-description-reception"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 trouble-support">
            <div className="row">
              <div className="col-12 title-trouble-support">
                <div className="text-trouble-support">{t('usefulPage.label_solving')}</div>
                <div className="description-trouble-support jp-font-sawarabi-gothic">
                  {t('usefulPage.label_solving_desc')}
                </div>
              </div>
            </div>
            <div className="row detail-support">
              <div className="col-md-1"></div>
              <div className="col-12 col-md-2 icon-left-detail-support">
                <img src={iconSupport1} alt="" className="icon-support" />
              </div>
              <div className="col-12 col-md-8">
                <div className="content-right-support">
                  <div className="title-support">{t('usefulPage.label_accepting')}</div>
                  <div
                    className="description-support jp-font-sawarabi-gothic d-none d-md-block"
                    dangerouslySetInnerHTML={{
                      __html: `${t('usefulPage.label_accepting_desc')}`,
                    }}
                  ></div>
                  {/* <div className="description-support jp-font-sawarabi-gothic d-block d-md-none">
                    {t('useful_page.our_customer.we_will_respond_to_the_troubles_mobile')}
                  </div> */}
                </div>
              </div>
              <div className="col-md-1"></div>

              <div className="col-md-1"></div>
              <div className="col-12 col-md-2 icon-left-detail-support">
                <img src={iconSupport2} alt="" className="icon-support" />
              </div>
              <div className="col-12 col-md-8">
                <div className="content-right-support">
                  <div className="title-support">{t('usefulPage.label_mainten')}</div>
                  <div className="description-support jp-font-sawarabi-gothic">
                    {t('usefulPage.label_mainten_desc')}
                  </div>
                </div>
              </div>
              <div className="col-md-1"></div>

              <div className="col-md-3"></div>
              <div className="col-12 col-md-8">
                <div className="row content-right-support d-none d-md-flex">
                  <div className="col-6">
                    <div className="example-support">
                      <div className="title"> {t('usefulPage.label_lumbing')}</div>
                      <div className="text-example jp-font-sawarabi-gothic">{t('usefulPage.label_lumbing_desc')}</div>
                    </div>
                    <div className="example-support">
                      <div className="title"> {t('usefulPage.label_house')}</div>
                      <div className="text-example jp-font-sawarabi-gothic">{t('usefulPage.label_house_desc')}</div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="example-support">
                      <div className="title"> {t('usefulPage.label_electrical')}</div>
                      <div className="text-example jp-font-sawarabi-gothic">
                        {t('usefulPage.label_electrical_desc')}
                      </div>
                    </div>
                    <div className="example-support">
                      <div className="title"> {t('usefulPage.label_locksmith')}</div>
                      <div className="text-example jp-font-sawarabi-gothic">{t('usefulPage.label_locksmith_desc')}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-1"></div>

              <div className="col-md-1"></div>
              <div className="col-12 col-md-2 icon-left-detail-support">
                <img src={iconSupport3} alt="" className="icon-support" />
              </div>
              <div className="col-12 col-md-8">
                <div className="content-right-support">
                  <div className="title-support">{t('usefulPage.label_drink')}</div>
                  <div className="description-support jp-font-sawarabi-gothic">{t('usefulPage.label_drink_desc')}</div>
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>

          <div className="col-12 other-support">
            <div className="row">
              <div className="col-12 col-md-4 text-other-support">{t('usefulPage.label_other')}</div>
              <div className="col-md-8"></div>
            </div>
            <div className="row detail-other-support">
              <div className="col-md-1"></div>
              <div className="col-12 col-md-2 icon-left-other">
                <img src={iconSupport4} alt="" className="icon-orther-support" />
              </div>
              <div className="col-12 col-md-8 content-right pr-0">
                <div className="title-orther-support">{t('usefulPage.label_other_desc')}</div>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>

          <div className="col-12 contact-support d-none d-md-flex">
            <div className="content">
              <div className="title-contact-support">{t('usefulPage.label_24h7day')}</div>
              <div className="info-contact">
                <div className="phone">
                  <a href={`tel: ${contact?.emailSupport}`}>
                    <img src={iconPhone} alt="" />
                    {contact?.phone}
                  </a>
                </div>
                <div className="email">
                  <a href={`mailto: ${contact?.emailSupport}`}>
                    <img src={iconEmail} alt="" />
                    {contact?.emailSupport}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 d-block d-md-none">
            <div className="contact-support-mobile">
              <div
                className="title-contact-support"
                dangerouslySetInnerHTML={{
                  __html: t('usefulPage.label_24h7day') || '',
                }}
              ></div>
              <div className="phone">
                <a href={`tel: ${contact?.phone}`}>
                  <img src={iconPhone} alt="" />
                  {contact?.phone}
                </a>
              </div>
              <div className="email">
                <a href={`mailto: ${contact?.emailSupport}`}>
                  <img src={iconEmail} alt="" />
                  {contact?.emailSupport}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader}
    </div>
  );
};
export default OurCustomer;
